import ListContacts from './api/ListContact/ListContact';
import DeleteContact from './api/DeleteContact/DeleteContact';
import { isEnabled } from './api/config';

export default {
    isEnabled,
    ListContacts,
    DeleteContact,
};

export type { PersonaInfo } from './models/PersonaInfo';
export type { Contact } from './models/Contact';
export { convertContactToPersonType } from './api/ListContact/responseConverter';
